var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-back",on:{"click":_vm.backClick}},[_c('i',{staticClass:"el-icon-arrow-left back-icon"}),_c('el-link',{staticClass:"back-txt"},[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }